import { render, staticRenderFns } from "./laporan_sejarah_op.vue?vue&type=template&id=4bb8265c&"
import script from "./laporan_sejarah_op.vue?vue&type=script&lang=js&"
export * from "./laporan_sejarah_op.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports